import React from "react";
import { MerchantApp } from "./merchant/MerchantApp";
import { AdminApp } from "./admin/AdminApp";

// A tiny path-based switch is all this needs: the merchant journey and the
// admin portal are two separate SPAs sharing one bundle and one API. Each
// manages its own internal "page" via component state rather than the
// History API (see docs/architecture.md for why this build has no
// react-router dependency) — acceptable since neither app requires
// deep-linkable sub-routes for the MVP.
export function App() {
  const isAdmin = typeof window !== "undefined" && window.location.pathname.startsWith("/admin");
  return isAdmin ? <AdminApp /> : <MerchantApp />;
}
